// @core/api/endpoints/booking/upsert_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingPolicyResponse,
  UpsertPolicyRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Upsert booking policy
 * Creates or updates a booking policy for a type or specific resource. Resource-level policies override type-level defaults.
 */
export async function UpsertPolicy(
  data: UpsertPolicyRequest,
  options?: RequestOptions
): Promise<BookingPolicyResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/policies`;
  const requestOptions = options;
  return client.put<BookingPolicyResponse>(requestPath, data, requestOptions);
}
